import React from 'react';
import { Text, Box, useTheme, Area } from '@ublend-npm/aulaui-core';

const NoSpace = () => {
  const { palette } = useTheme();
  return (
    <Box display="flex" justifyContent="center" padding="1rem 0">
      <Area
        display="flex"
        alignItems="center"
        flexDirection="column"
        sx={{
          borderRadius: '0.5rem',
        }}
        width="100%"
      >
        <Text
          kind="p2"
          pt="0.10rem"
          pb="0.68rem"
          fontWeight="600"
          fontSize="1rem"
        >
          No recently viewed spaces
        </Text>
        <Text
          fontSize="1rem"
          pl=".5rem"
          pr=".5rem"
          pb=".25rem"
          fontWeight="400"
          textAlign="center"
          lineHeight="143%"
          color={
            palette?.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.7)'
              : 'rgba(0, 0, 0, 0.6)'
          }
        >
          Your recently viewed spaces are listed here for easy reference and
          quick navigation.
        </Text>
      </Area>
    </Box>
  );
};

export default NoSpace;
